import { useState } from 'react';
import { useI18n } from '../i18n';
import ShareModal from './ShareModal';
import { buildShareText, buildUnlimitedText, encodeGrid } from '../lib/share';
import { makeShareImage } from '../lib/shareImage';
import { buildPath, type ModeKey } from '../router';
import type { Country } from '../lib/countries';

const SITE = 'https://geodle.org';

export default function ShareBar({
  mode,
  num,
  guesses,
  answer,
  streak,
  endless = false,
  best = 0,
}: {
  mode: string;
  num: number;
  guesses: Country[];
  answer: Country;
  streak: number;
  endless?: boolean;
  best?: number;
}) {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);

  const url = SITE + buildPath(lang, mode as ModeKey, endless);
  const text = endless
    ? buildUnlimitedText(mode, guesses, answer, streak, best)
    : buildShareText(mode, num, guesses, answer, streak);
  const grid = encodeGrid(guesses, answer);
  const embed = `<a href="${url}"><img src="${SITE}/api/og?type=game&mode=${mode}&num=${num}&streak=${streak}&grid=${grid}&lang=${lang}" alt="GeoDle ${mode}" width="600" height="315"></a>`;

  return (
    <div className="share-bar">
      <button className="share-trigger" onClick={() => setOpen(true)}>
        {t.share}
      </button>
      {open && (
        <ShareModal
          text={text}
          url={url}
          embed={embed}
          makeImage={() => makeShareImage({ mode, num, guesses, answer, streak, lang, endless, best })}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
